<script>
import ChartDateLine from '@/components/chart/ChartDateLine.vue';

export default {
  name: 'UserDetailChartLineTile',
  components: { ChartDateLine },
  props: {
    config: Object,
  },
  computed: {
    chartId() {
      return this._id; // eslint-disable-line no-underscore-dangle
    },
  },
};
</script>

<template lang="pug">
.b-user-detail-date-line-tile
  ._border-line(:style="`background-color: ${config.color}`")
  ._chart-container
    ._label {{ config.tile.label }}
    ._chart
      ChartDateLine(:data="config.tile.data" :id="chartId" :chartColor="config.color")
    ._info
      ._info-item(v-for="info in config.tile.info" :key="info.title")
        ._value(:style="`color: ${config.color}`") {{ info.value }}
        ._title {{ info.title }}
</template>

<style scoped lang="scss">
.user-detail-date-line-tile {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08);
  background: rgb(255, 255, 255);
  position: relative;

  &__border-line {
    width: 6px;
    position: absolute;
    left: 0;
    height: 100%;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  }

  &__chart-container {
    box-sizing: border-box;
    padding: 23px 33px 26px 30px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;
  }

  &__label {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: normal;
    text-align: left;
    padding-bottom: 25px;
  }

  &__chart {
    width: 100%;
    height: 100px;
    padding-bottom: 35px;
  }

  &__info {
    display: flex;
    align-items: center;
    gap: 85px;
  }

  &__info-item {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__value {
    font-family: Geometria, sans-serif;
    font-size: 30px;
    font-weight: 700;
    line-height: 38px;
    letter-spacing: normal;
    text-align: left;
  }

  &__title {
    color: rgb(120, 140, 161);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: normal;
    text-align: left;
  }
}

.background-yellow {
  background-color: rgba(255, 216, 2, 1);
}

.background-orange {
  background-color: rgba(252, 142, 1, 1);
}

.background-red {
  background-color: rgba(232, 49, 0, 1);
}

.text-yellow {
  color: rgba(255, 216, 2, 1);
}

.text-orange {
  color: rgba(252, 142, 1, 1);
}

.text-red {
  color: rgba(232, 49, 0, 1);
}
</style>
